import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_AIRPORT_VENDOR_LIST, SUPERSET_AIRPORT_VENDOR_LIST_ERROR, SUPERSET_AIRPORT_VENDOR_LIST_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetAirportVendorList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_AIRPORT_VENDOR_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_AIRPORT_VENDOR_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_AIRPORT_VENDOR_LIST_ERROR, payload: error });
  }
}

export function* watchSupersetAirportVendorList() {
  yield takeEvery(SUPERSET_AIRPORT_VENDOR_LIST, supersetAirportVendorList);
}

function* supersetAirportVendorListSaga() {
  yield all([fork(watchSupersetAirportVendorList)]);
}

export default supersetAirportVendorListSaga;
